import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list__item list__item-edit" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_4 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_time = _resolveComponent("select-time")!

  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.wordEdit.english) = $event)),
      class: "list__english",
      placeholder: _ctx.wordData.english
    }, null, 8, _hoisted_2), [
      [_vModelText, _ctx.wordEdit.english]
    ]),
    _hoisted_3,
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.wordEdit.russian) = $event)),
      class: "list__russian",
      placeholder: _ctx.wordData.russian
    }, null, 8, _hoisted_4), [
      [_vModelText, _ctx.wordEdit.russian]
    ]),
    _createVNode(_component_select_time, {
      "time-edit": _ctx.wordData.currentTime,
      onSetTime: _ctx.setTime
    }, null, 8, ["time-edit", "onSetTime"])
  ]))
}